export default (props, vars) => props?.['name'] === 'expand_more';
